export type WorkspaceMotionProfile = 'default' | 'reduced';

export interface VisualThemeProfile {
	profileId: 'dark-cosmic-editorial';
	canvasBase: string;
	accent: string;
	panelSurface: string;
	panelBorder: string;
	textPrimary: string;
	textSecondary: string;
	fontSans: string[];
	fontMono: string[];
	motionProfile: WorkspaceMotionProfile;
}

export function createVisualThemeProfile(motionProfile: WorkspaceMotionProfile = 'default'): VisualThemeProfile {
	return {
		profileId: 'dark-cosmic-editorial',
		canvasBase: '#02030a',
		accent: '#63e6ff',
		panelSurface: 'rgba(3, 9, 24, .56)',
		panelBorder: 'rgba(139, 227, 255, .24)',
		textPrimary: '#f7fbff',
		textSecondary: 'rgba(190, 214, 236, .72)',
		fontSans: ['Geist', 'Segoe UI Variable', 'Segoe UI', 'system-ui', 'sans-serif'],
		fontMono: ['Geist Mono', 'JetBrains Mono', 'Cascadia Code', 'Consolas', 'monospace'],
		motionProfile,
	};
}